import script from "./OnWorkplace.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnWorkplace.vue?vue&type=script&setup=true&lang=ts"

import "./OnWorkplace.vue?vue&type=style&index=0&id=7a590f86&lang=css"

const __exports__ = script;

export default __exports__